var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1049_13167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.65606 31.0553V28.2332H8.4782V25.4111H16.9446V28.2332H14.1225V31.0553H11.3003V33.8775H8.4782V39.5217H14.1225V36.6996H16.9446V33.8775H19.7667V31.0553H22.5889V39.5217H19.7667V42.3439H16.9446V45.1779H2.82207V31.0553H5.65606Z",
    fill: "#FBC04E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7666 33.8774H16.9445V36.6995H14.1223V39.5216H8.47807V33.8774H11.3002V31.0552H14.1223V28.2331H19.7666V33.8774Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8887 36.6995H31.0547V39.5216H28.2325V42.3438H25.4104V33.8774H28.2325V31.0552H31.0547V28.2331H33.8887V36.6995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8898 25.4111H36.7119V28.2332H33.8898V25.4111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7111 22.5889H39.5332V25.4111H36.7111V22.5889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0676 19.7669H36.7119V22.5891H31.0676V19.7669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5333 19.7669H42.3555V22.5891H39.5333V19.7669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5893 16.9446V14.1106H25.4114V11.2885H28.2335V16.9446H31.0557V19.7668H28.2335V22.5889H25.4114V25.411H22.5893V28.2332H19.7671V25.411H16.945V22.5889H5.65645V19.7668H8.47859V16.9446H11.3007V14.1106H19.7671V16.9446H22.5893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7111 16.9446H39.5332V19.7667H36.7111V16.9446Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3556 16.9447H39.5335V11.2885H36.7113V8.46639H31.0552V5.64426H28.2331V2.82212H45.1777V19.7668H42.3556V16.9447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7667 11.2885H22.5889V14.1106H19.7667V11.2885Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8898 11.2885H36.7119V14.1106H33.8898V11.2885Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.589 8.46638H25.4111V11.2885H22.589V8.46638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2335 8.46638H31.0557V11.2885H28.2335V8.46638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4113 5.64425H28.2334V8.46639H25.4113V5.64425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83366 45.1779H16.9443V48H2.83366V45.1779Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9445 42.3439H19.7666V45.1661H16.9445V42.3439Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4113 42.3439H28.2334V45.1661H25.4113V42.3439Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5894 39.5219V31.0555H19.7672V28.2333H22.5894V25.4112H25.4115V22.5891H28.2337V19.7669H31.0558V22.5891H36.7119V25.4112H33.8898V28.2333H31.0558V31.0555H28.2337V33.8776H25.4115V42.344H19.7672V39.5219H22.5894Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2335 39.5218H31.0557V42.3439H28.2335V39.5218Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0665 36.6996H33.8887V39.5217H31.0665V36.6996Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.000844002 31.0554H2.82129V45.1661H-0.000844002V31.0554Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8898 28.2331H36.7119V36.6995H33.8898V28.2331Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83412 28.2331H5.65625V31.0552H2.83412V28.2331Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9445 25.4111H19.7666V28.2332H16.9445V25.4111Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7111 25.4111H39.5332V28.2332H36.7111V25.4111Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9443 22.5889V25.4111H8.47793V28.2332H5.6558V22.5889H16.9443Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5333 22.5889H42.3555V25.4111H39.5333V22.5889Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83412 19.7669H5.65625V22.5891H2.83412V19.7669Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7111 19.7669H39.5332V22.5891H36.7111V19.7669Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3556 19.7669H45.1777V22.5891H42.3556V19.7669Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.65638 16.9446H8.47852V19.7667H5.65638V16.9446Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5333 16.9446H42.3555V19.7667H39.5333V16.9446Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47767 14.1106H11.2998V16.9328H8.47767V14.1106Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7667 14.1106H22.5889V16.9328H19.7667V14.1106Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2328 16.9446V11.2885H31.0549V8.46638H36.7111V11.2885H33.8889V14.1106H36.7111V11.2885H39.5332V16.9446H36.7111V19.7668H31.0549V16.9446H28.2328Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1779 2.82212H48V19.7668H45.1779V2.82212Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3002 11.2885H19.7666V14.1106H11.3002V11.2885Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.589 11.2885H25.4111V14.1106H22.589V11.2885Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7667 8.46638H22.5889V11.2885H19.7667V8.46638Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4113 8.46638H28.2334V11.2885H25.4113V8.46638Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.589 5.64425H25.4111V8.46639H22.589V5.64425Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2335 5.64425H31.0557V8.46639H28.2335V5.64425Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4113 2.82212H28.2334V5.64426H25.4113V2.82212Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2331 0H45.1777V2.82213H28.2331V0Z",
    fill: "#0E151D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1049_13167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "matrix(-1 0 0 1 48 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.b07b8bf6c6b6ac10b519abc73096f44b.svg";
export { ForwardRef as ReactComponent };